(function () {
  'use strict';

  const MEMORY_NAME_PREFIX = 'メモリを選択する';
  const DEFAULT_TEXT = '8GB';

  const WRAPPER_CLASS = 'memory-dropdown';
  const MOUNT_CLASS = 'memory-dropdown-mount';
  const NATIVE_FIELDSET_CLASS = 'memory-native-fieldset';

  let defaultApplied = false;
  let userSelected = false;
  let renderScheduled = false;
  let observerStarted = false;

  let currentMemoryAdditionalPrice = 0;
  let gpoObserverStarted = false;
  let optionPriceUpdateScheduled = false;

  function normalizeText(text) {
    return String(text || '')
      .replace(/　/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeNoSpace(text) {
    return String(text || '')
      .replace(/　/g, '')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase();
  }

  function cleanText(text) {
    return normalizeText(text)
      .replace(/バリエーションは売り切れているか販売できません/g, '')
      .trim();
  }

  function escapeSelector(value) {
    if (
      window.CSS &&
      typeof window.CSS.escape === 'function'
    ) {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function toHalfWidthNumbers(text) {
    return String(text || '').replace(
      /[０-９]/g,
      function (char) {
        return String.fromCharCode(
          char.charCodeAt(0) - 0xFEE0
        );
      }
    );
  }

  function formatYenAmountText(text) {
    const normalized = toHalfWidthNumbers(text);

    return normalized.replace(
      /([+＋]\s*[¥￥]\s*)(\d[\d,]*)/g,
      function (match, prefix, amount) {
        const rawAmount = String(
          amount || ''
        ).replace(/,/g, '');

        const number = Number(rawAmount);

        if (!Number.isFinite(number)) {
          return match;
        }

        const formattedPrefix = String(
          prefix || ''
        ).replace('＋', '+');

        return (
          formattedPrefix +
          number.toLocaleString('ja-JP')
        );
      }
    );
  }

  function formatYen(number) {
    const safeNumber = Number(number || 0);

    return (
      '¥' +
      safeNumber.toLocaleString('ja-JP')
    );
  }

  function formatAdditionalPriceSuffix(number) {
    const safeNumber = Number(number || 0);

    if (
      !Number.isFinite(safeNumber) ||
      safeNumber <= 0
    ) {
      return '';
    }

    return (
      ' (+ ' +
      formatYen(safeNumber) +
      ')'
    );
  }

  function getMemoryMappedAdditionalPrice(text) {
    const normalized = normalizeNoSpace(
      toHalfWidthNumbers(text)
    );

    if (
      normalized.includes('メモリ16gb') ||
      normalized.includes('16gb')
    ) {
      return 16000;
    }

    return 0;
  }

  function buildMemoryPartsFromPlainLabel(labelText) {
    const label = cleanText(labelText);

    const additionalPrice =
      getMemoryMappedAdditionalPrice(label);

    return {
      label: label,
      meta: '',
      full: label,
      titleSuffix:
        formatAdditionalPriceSuffix(
          additionalPrice
        ),
      displayText: label,
      additionalPrice: additionalPrice
    };
  }

  function parseOptionText(text) {
    const formatted = formatYenAmountText(
      cleanText(text)
    );

    const match = formatted.match(
      /^(.*?)[（(]\s*([^（）()]*)\s*[）)]\s*$/
    );

    if (!match) {
      return buildMemoryPartsFromPlainLabel(
        formatted
      );
    }

    const label = cleanText(match[1]);
    const rawMeta = cleanText(match[2]);

    const meta =
      '（' + rawMeta + '）';

    const isFree =
      rawMeta.indexOf('無料') !== -1;

    const combinedText =
      label + meta;

    let additionalPrice = 0;

    const normalizedMeta =
      toHalfWidthNumbers(rawMeta);

    const plusMatch =
      normalizedMeta.match(
        /[+＋]\s*[¥￥]?\s*([\d,]+)/
      );

    if (plusMatch) {
      const parsed = Number(
        String(
          plusMatch[1] || ''
        ).replace(/,/g, '')
      );

      additionalPrice =
        Number.isFinite(parsed)
          ? parsed
          : 0;
    }

    if (!additionalPrice) {
      additionalPrice =
        getMemoryMappedAdditionalPrice(label);
    }

    return {
      label: label,
      meta: meta,
      full: combinedText,
      titleSuffix:
        isFree
          ? ''
          : formatAdditionalPriceSuffix(
              additionalPrice
            ),
      displayText:
        isFree
          ? combinedText
          : label,
      additionalPrice:
        additionalPrice
    };
  }

  function parseYenToNumber(text) {
    const normalized =
      toHalfWidthNumbers(text);

    const raw = String(
      normalized || ''
    ).replace(/[^\d]/g, '');

    if (!raw) {
      return 0;
    }

    const number = Number(raw);

    return Number.isFinite(number)
      ? number
      : 0;
  }

  function getMemoryAdditionalPrice(
    selectedParts
  ) {
    if (!selectedParts) {
      return 0;
    }

    if (
      Number.isFinite(
        Number(
          selectedParts.additionalPrice
        )
      )
    ) {
      return Number(
        selectedParts.additionalPrice
      );
    }

    const source =
      selectedParts.titleSuffix ||
      selectedParts.meta ||
      selectedParts.full ||
      '';

    const normalized =
      toHalfWidthNumbers(source);

    if (!/[+＋]/.test(normalized)) {
      return getMemoryMappedAdditionalPrice(
        selectedParts.label ||
        selectedParts.displayText ||
        source
      );
    }

    const match = normalized.match(
      /[+＋]\s*[¥￥]\s*([\d,]+)/
    );

    if (!match) {
      return getMemoryMappedAdditionalPrice(
        selectedParts.label ||
        selectedParts.displayText ||
        source
      );
    }

    const number = Number(
      String(
        match[1] || ''
      ).replace(/,/g, '')
    );

    return Number.isFinite(number)
      ? number
      : getMemoryMappedAdditionalPrice(
          selectedParts.label ||
          selectedParts.displayText ||
          source
        );
  }

  /*
   * ==========================================================
   * 上部の商品価格横に
   * 「（オプション価格 ¥xx,xxx 含む）」を表示
   *
   * 重要：
   * Globoの .gpo-total は読み取り専用
   * このJSからGloboの金額は書き換えない
   * ==========================================================
   */

  function getMainProductInfo() {
    const note = document.querySelector(
      '.pcnext-option-price-note'
    );

    if (note) {
      const productInfo =
        note.closest('product-info');

      if (productInfo) {
        return productInfo;
      }
    }

    return (
      document.querySelector(
        'product-info[id^="MainProduct-"]'
      ) ||
      document.querySelector(
        'product-info'
      ) ||
      null
    );
  }

  function getRealGpoTotalElement() {
    const productInfo =
      getMainProductInfo();

    if (productInfo) {
      const element =
        productInfo.querySelector(
          '.gpo-total:not(.pcnext-memory-created-gpo-total)'
        );

      if (element) {
        return element;
      }
    }

    return document.querySelector(
      '.gpo-total:not(.pcnext-memory-created-gpo-total)'
    );
  }

  function getRealGpoMoneyElement() {
    const gpoTotal =
      getRealGpoTotalElement();

    if (!gpoTotal) {
      return null;
    }

    return (
      gpoTotal.querySelector(
        '.gpo-total-text .money'
      ) ||
      gpoTotal.querySelector(
        '.money'
      ) ||
      null
    );
  }

  function getNativeGpoAdditionalPrice() {
    const moneyElement =
      getRealGpoMoneyElement();

    if (!moneyElement) {
      return 0;
    }

    return parseYenToNumber(
      moneyElement.textContent
    );
  }

  function getCombinedAdditionalPrice() {
    const gpoAdditionalPrice =
      getNativeGpoAdditionalPrice();

    const memoryAdditionalPrice =
      Number(
        currentMemoryAdditionalPrice || 0
      );

    return (
      Number(gpoAdditionalPrice || 0) +
      (
        Number.isFinite(
          memoryAdditionalPrice
        )
          ? memoryAdditionalPrice
          : 0
      )
    );
  }

  function updateProductPriceOptionNote() {
    const note = document.querySelector(
      '.pcnext-option-price-note'
    );

    if (!note) {
      return;
    }

    const amount =
      getCombinedAdditionalPrice();

    const newText =
      Number.isFinite(amount) &&
      amount > 0
        ? (
            '（オプション価格 ' +
            formatYen(amount) +
            ' 含む）'
          )
        : '';

    /*
     * 同じ表示ならDOMを触らない
     * スマホ固定カート等の不要な再計算を防ぐため
     */
    if (
      note.textContent !== newText
    ) {
      note.textContent = newText;
    }
  }

  function scheduleOptionPriceUpdate() {
    if (optionPriceUpdateScheduled) {
      return;
    }

    optionPriceUpdateScheduled = true;

    window.requestAnimationFrame(
      function () {
        optionPriceUpdateScheduled = false;

        updateProductPriceOptionNote();
      }
    );
  }

  function isGpoTotalNode(node) {
    if (!node) {
      return false;
    }

    if (node.nodeType === 3) {
      return !!(
        node.parentElement &&
        node.parentElement.closest(
          '.gpo-total'
        )
      );
    }

    if (node.nodeType !== 1) {
      return false;
    }

    if (
      node.matches &&
      node.matches(
        '.gpo-total, .gpo-total *'
      )
    ) {
      return true;
    }

    if (
      node.querySelector &&
      node.querySelector(
        '.gpo-total'
      )
    ) {
      return true;
    }

    return false;
  }

  function startGpoObserver() {
    if (gpoObserverStarted) {
      return;
    }

    gpoObserverStarted = true;

    const root =
      getMainProductInfo() ||
      document.body;

    const observer =
      new MutationObserver(
        function (mutations) {
          const shouldUpdate =
            mutations.some(
              function (mutation) {
                if (
                  isGpoTotalNode(
                    mutation.target
                  )
                ) {
                  return true;
                }

                const addedNodes =
                  Array.from(
                    mutation.addedNodes ||
                    []
                  );

                const removedNodes =
                  Array.from(
                    mutation.removedNodes ||
                    []
                  );

                return addedNodes
                  .concat(removedNodes)
                  .some(
                    isGpoTotalNode
                  );
              }
            );

          if (shouldUpdate) {
            scheduleOptionPriceUpdate();
          }
        }
      );

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /*
   * ==========================================================
   * メモリドロップダウン
   * ==========================================================
   */

  function getMemoryInputSelector() {
    return (
      'variant-selects input[type="radio"][name^="' +
      MEMORY_NAME_PREFIX +
      '"]'
    );
  }

  function getTargetElements() {
    const firstRadio =
      document.querySelector(
        getMemoryInputSelector()
      );

    if (!firstRadio) {
      return null;
    }

    const fieldset =
      firstRadio.closest(
        'fieldset'
      );

    const variantSelects =
      firstRadio.closest(
        'variant-selects'
      );

    if (
      !fieldset ||
      !variantSelects
    ) {
      return null;
    }

    return {
      fieldset: fieldset,
      variantSelects:
        variantSelects
    };
  }

  function getRadios(fieldset) {
    return Array.from(
      fieldset.querySelectorAll(
        'input[type="radio"][name^="' +
        MEMORY_NAME_PREFIX +
        '"]'
      )
    );
  }

  function getLabel(
    fieldset,
    radio
  ) {
    if (!radio.id) {
      return null;
    }

    return fieldset.querySelector(
      'label[for="' +
      escapeSelector(
        radio.id
      ) +
      '"]'
    );
  }

  function getRadioText(
    fieldset,
    radio
  ) {
    const label =
      getLabel(
        fieldset,
        radio
      );

    const text =
      cleanText(
        label
          ? label.textContent
          : radio.value
      );

    return formatYenAmountText(
      text
    );
  }

  function getRadioParts(
    fieldset,
    radio
  ) {
    return parseOptionText(
      getRadioText(
        fieldset,
        radio
      )
    );
  }

  function getSelectedRadio(
    radios
  ) {
    return (
      radios.find(
        function (radio) {
          return radio.checked;
        }
      ) ||
      radios[0] ||
      null
    );
  }

  function applyDefault8GB(
    fieldset,
    radios
  ) {
    if (defaultApplied) {
      return;
    }

    if (userSelected) {
      return;
    }

    defaultApplied = true;

    const defaultRadio =
      radios.find(
        function (radio) {
          return getRadioText(
            fieldset,
            radio
          ).includes(
            DEFAULT_TEXT
          );
        }
      );

    if (
      !defaultRadio ||
      defaultRadio.disabled ||
      defaultRadio.checked
    ) {
      return;
    }

    defaultRadio.click();

    setTimeout(
      scheduleRender,
      80
    );

    setTimeout(
      scheduleRender,
      250
    );

    setTimeout(
      scheduleRender,
      500
    );
  }

  function getSignature(
    fieldset,
    radios
  ) {
    return radios
      .map(
        function (radio) {
          const parts =
            getRadioParts(
              fieldset,
              radio
            );

          return [
            radio.id,
            parts.full,
            parts.displayText,
            parts.titleSuffix,
            parts.additionalPrice,
            radio.checked
              ? 'checked'
              : 'unchecked',
            radio.disabled
              ? 'disabled'
              : 'enabled'
          ].join('::');
        }
      )
      .join('||');
  }

  function removeDuplicateWrappers(
    keepWrapper
  ) {
    document
      .querySelectorAll(
        '.' + WRAPPER_CLASS
      )
      .forEach(
        function (wrapper) {
          if (
            wrapper !== keepWrapper
          ) {
            wrapper.remove();
          }
        }
      );
  }

  function getOrCreateWrapper(
    variantSelects
  ) {
    const mount =
      document.querySelector(
        '.' + MOUNT_CLASS
      );

    if (mount) {
      let wrapper =
        mount.querySelector(
          ':scope > .' +
          WRAPPER_CLASS
        );

      if (!wrapper) {
        wrapper =
          document.createElement(
            'div'
          );

        wrapper.className =
          WRAPPER_CLASS;

        mount.appendChild(
          wrapper
        );
      }

      removeDuplicateWrappers(
        wrapper
      );

      return wrapper;
    }

    const parent =
      variantSelects.parentNode;

    if (!parent) {
      return null;
    }

    let wrapper =
      variantSelects
        .previousElementSibling;

    if (
      wrapper &&
      wrapper.classList &&
      wrapper.classList.contains(
        WRAPPER_CLASS
      )
    ) {
      removeDuplicateWrappers(
        wrapper
      );

      return wrapper;
    }

    wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      WRAPPER_CLASS;

    parent.insertBefore(
      wrapper,
      variantSelects
    );

    removeDuplicateWrappers(
      wrapper
    );

    return wrapper;
  }

  function getBaseTitle(
    fieldset
  ) {
    const legend =
      fieldset.querySelector(
        'legend'
      );

    const text =
      cleanText(
        legend
          ? legend.textContent
          : ''
      );

    return (
      text ||
      'メモリを選択する'
    );
  }

  function getDisplayTitle(
    fieldset,
    selectedParts
  ) {
    const baseTitle =
      getBaseTitle(
        fieldset
      );

    if (
      selectedParts &&
      selectedParts.titleSuffix
    ) {
      return (
        baseTitle +
        selectedParts.titleSuffix
      );
    }

    return baseTitle;
  }

  function createOptionItem(
    fieldset,
    radio,
    selectedRadio
  ) {
    const item =
      document.createElement(
        'li'
      );

    const parts =
      getRadioParts(
        fieldset,
        radio
      );

    item.className =
      'memory-dropdown__item';

    /*
     * 選択肢：
     *
     * メモリ8GB
     * メモリ16GB (+ ¥16,000)
     */
    item.textContent =
      (
        parts.displayText ||
        parts.full
      ) +
      (
        parts.titleSuffix ||
        ''
      );

    item.dataset.radioId =
      radio.id || '';

    if (
      selectedRadio &&
      selectedRadio.id ===
        radio.id
    ) {
      item.classList.add(
        'is-selected'
      );
    }

    if (radio.disabled) {
      item.classList.add(
        'is-disabled'
      );

      item.dataset.disabled =
        'true';
    } else {
      item.dataset.disabled =
        'false';
    }

    return item;
  }

  function renderDropdown() {
    const target =
      getTargetElements();

    if (!target) {
      currentMemoryAdditionalPrice =
        0;

      scheduleOptionPriceUpdate();

      return;
    }

    const fieldset =
      target.fieldset;

    const variantSelects =
      target.variantSelects;

    const radios =
      getRadios(
        fieldset
      );

    if (!radios.length) {
      currentMemoryAdditionalPrice =
        0;

      scheduleOptionPriceUpdate();

      return;
    }

    fieldset.classList.add(
      NATIVE_FIELDSET_CLASS
    );

    applyDefault8GB(
      fieldset,
      radios
    );

    const latestRadios =
      getRadios(
        fieldset
      );

    const selectedRadio =
      getSelectedRadio(
        latestRadios
      );

    const selectedParts =
      selectedRadio
        ? getRadioParts(
            fieldset,
            selectedRadio
          )
        : {
            label: '',
            meta: '',
            full: '',
            titleSuffix: '',
            displayText: '',
            additionalPrice: 0
          };

    currentMemoryAdditionalPrice =
      getMemoryAdditionalPrice(
        selectedParts
      );

    /*
     * 上の商品価格横を更新
     */
    scheduleOptionPriceUpdate();

    /*
     * Globo監視開始
     */
    startGpoObserver();

    const signature =
      getSignature(
        fieldset,
        latestRadios
      );

    const wrapper =
      getOrCreateWrapper(
        variantSelects
      );

    if (!wrapper) {
      return;
    }

    if (
      wrapper.dataset.signature ===
      signature
    ) {
      return;
    }

    const wasOpen =
      wrapper.classList.contains(
        'is-open'
      );

    wrapper.innerHTML = '';

    const title =
      document.createElement(
        'div'
      );

    title.className =
      'memory-dropdown__label';

    title.textContent =
      getDisplayTitle(
        fieldset,
        selectedParts
      );

    const current =
      document.createElement(
        'div'
      );

    current.className =
      'memory-dropdown__current';

    current.textContent =
      selectedParts.displayText;

    const button =
      document.createElement(
        'button'
      );

    button.type = 'button';

    button.className =
      'memory-dropdown__button';

    button.textContent =
      selectedParts.displayText;

    button.setAttribute(
      'aria-expanded',
      wasOpen
        ? 'true'
        : 'false'
    );

    const menu =
      document.createElement(
        'ul'
      );

    menu.className =
      'memory-dropdown__menu';

    latestRadios.forEach(
      function (
        radio,
        index
      ) {
        if (!radio.id) {
          radio.id =
            'memory-radio-' +
            Date.now() +
            '-' +
            index;
        }

        menu.appendChild(
          createOptionItem(
            fieldset,
            radio,
            selectedRadio
          )
        );
      }
    );

    wrapper.appendChild(
      title
    );

    wrapper.appendChild(
      current
    );

    wrapper.appendChild(
      button
    );

    wrapper.appendChild(
      menu
    );

    if (wasOpen) {
      wrapper.classList.add(
        'is-open'
      );
    }

    wrapper.dataset.signature =
      signature;
  }

  function scheduleRender() {
    if (renderScheduled) {
      return;
    }

    renderScheduled = true;

    window.requestAnimationFrame(
      function () {
        renderScheduled = false;

        renderDropdown();
      }
    );
  }

  function closeAllDropdowns() {
    document
      .querySelectorAll(
        '.' + WRAPPER_CLASS
      )
      .forEach(
        function (dropdown) {
          dropdown.classList.remove(
            'is-open'
          );

          const button =
            dropdown.querySelector(
              '.memory-dropdown__button'
            );

          if (button) {
            button.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        }
      );
  }

  document.addEventListener(
    'click',
    function (event) {
      const dropdown =
        event.target.closest(
          '.' + WRAPPER_CLASS
        );

      if (!dropdown) {
        closeAllDropdowns();

        return;
      }

      const button =
        event.target.closest(
          '.memory-dropdown__button'
        );

      if (button) {
        const isOpen =
          dropdown.classList.contains(
            'is-open'
          );

        closeAllDropdowns();

        if (!isOpen) {
          dropdown.classList.add(
            'is-open'
          );

          button.setAttribute(
            'aria-expanded',
            'true'
          );
        }

        return;
      }

      const item =
        event.target.closest(
          '.memory-dropdown__item'
        );

      if (!item) {
        return;
      }

      if (
        item.dataset.disabled ===
        'true'
      ) {
        return;
      }

      const radio =
        document.getElementById(
          item.dataset.radioId
        );

      if (
        !radio ||
        radio.disabled
      ) {
        return;
      }

      userSelected = true;

      closeAllDropdowns();

      /*
       * 元のShopifyバリエーションを
       * 実際にクリック
       */
      radio.click();

      /*
       * Shopify側の
       * バリエーション再描画に追従
       */
      setTimeout(
        scheduleRender,
        50
      );

      setTimeout(
        scheduleRender,
        150
      );

      setTimeout(
        scheduleRender,
        300
      );

      setTimeout(
        scheduleRender,
        600
      );

      setTimeout(
        scheduleRender,
        1000
      );

      /*
       * 商品価格横の
       * オプション価格も更新
       */
      setTimeout(
        scheduleOptionPriceUpdate,
        80
      );

      setTimeout(
        scheduleOptionPriceUpdate,
        250
      );

      setTimeout(
        scheduleOptionPriceUpdate,
        600
      );
    }
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target.matches(
          'input[type="radio"][name^="' +
          MEMORY_NAME_PREFIX +
          '"]'
        )
      ) {
        return;
      }

      setTimeout(
        scheduleRender,
        30
      );

      setTimeout(
        scheduleRender,
        150
      );

      setTimeout(
        scheduleRender,
        300
      );

      setTimeout(
        scheduleRender,
        600
      );

      setTimeout(
        scheduleOptionPriceUpdate,
        80
      );

      setTimeout(
        scheduleOptionPriceUpdate,
        250
      );

      setTimeout(
        scheduleOptionPriceUpdate,
        600
      );
    }
  );

  function isRelevantMutationNode(
    node
  ) {
    if (
      !node ||
      node.nodeType !== 1
    ) {
      return false;
    }

    if (
      node.matches &&
      node.matches(
        'variant-selects, fieldset, input, label, .' +
        WRAPPER_CLASS +
        ', .' +
        MOUNT_CLASS
      )
    ) {
      return true;
    }

    if (
      node.querySelector &&
      node.querySelector(
        getMemoryInputSelector() +
        ', .' +
        WRAPPER_CLASS +
        ', .' +
        MOUNT_CLASS
      )
    ) {
      return true;
    }

    return false;
  }

  function startObserver() {
    if (observerStarted) {
      return;
    }

    observerStarted = true;

    /*
     * document.body全体ではなく、
     * 基本的に商品情報部分だけ監視
     */
    const root =
      getMainProductInfo() ||
      document.body;

    const observer =
      new MutationObserver(
        function (mutations) {
          const shouldRender =
            mutations.some(
              function (mutation) {
                const addedNodes =
                  Array.from(
                    mutation.addedNodes ||
                    []
                  );

                const removedNodes =
                  Array.from(
                    mutation.removedNodes ||
                    []
                  );

                return addedNodes
                  .concat(
                    removedNodes
                  )
                  .some(
                    isRelevantMutationNode
                  );
              }
            );

          if (shouldRender) {
            scheduleRender();
          }
        }
      );

    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );
  }

  /*
   * 旧バージョンで生成していた
   * 仮のGlobo合計欄が残っている場合だけ削除
   */
  function removeOldCreatedGpoTotals() {
    document
      .querySelectorAll(
        '.pcnext-memory-created-gpo-total'
      )
      .forEach(
        function (element) {
          element.remove();
        }
      );
  }

  function init() {
    removeOldCreatedGpoTotals();

    startObserver();
    startGpoObserver();

    scheduleRender();
    scheduleOptionPriceUpdate();

    /*
     * 初期ロード時、
     * Shopify / Globoの
     * 読み込みタイミング差を吸収
     */
    setTimeout(
      scheduleRender,
      200
    );

    setTimeout(
      scheduleRender,
      600
    );

    setTimeout(
      scheduleRender,
      1200
    );

    setTimeout(
      scheduleOptionPriceUpdate,
      300
    );

    setTimeout(
      scheduleOptionPriceUpdate,
      800
    );

    setTimeout(
      scheduleOptionPriceUpdate,
      1500
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();